<div class="m-organize-table-columns">
    <div class="m-organize-table-columns__header">
        <h2 class="m-organize-table-columns__title">{{ $i18n.translate('m-organize-table-columns:title') }}</h2>
        <p>{{ $i18n.translate('m-organize-table-columns:helper-1') }} ({{ numberDisplayedColumns }})</p>
    </div>

    <ul class="m-organize-table-columns__visible-columns"
        v-m-sortable="true"
        :items="displayedColumns"
        @sortable:move="moveColumn">
        <m-list-item v-for="(column, index) in displayedColumns"
                     :key="column.propName"
                     class="m-organize-table-columns__list-item"
                     :disabled="column.fixed"
                     :can-drag="isDraggable(column)"
                     :can-drop="isDroppable(column)">
            <div class="m-organize-table-columns__item">
                <div class="m-organize-table-columns__item-title">
                    <m-icon v-if="column.fixed"
                            name="m-svg__lock" />
                    <m-icon v-else
                            name="m-svg__drag-vertical" />
                    <span class="m-organize-table-columns__item-title-text">
                        {{column.title}}
                    </span>
                </div>
                <m-icon-button @click="removeColumn(column)"
                               button-size="20px"
                               v-if="!column.fixed"
                               icon-name="delete" />
            </div>
        </m-list-item>
    </ul>

    <template v-if="numberHiddenColumns > 0">
        <div class="m-organize-table-columns__header">
            <p>{{ $i18n.translate('m-organize-table-columns:helper-2') }}</p>
        </div>

        <ul class="m-organize-table-columns__hidden-columns">
            <m-list-item v-for="(column, index) in hiddenColumns"
                         :key="index"
                         class="m-organize-table-columns__list-item">
                <div class="m-organize-table-columns__item">
                    <div class="m-organize-table-columns__item-title">
                        <span class="m-organize-table-columns__item-title-text">
                            {{ column.title }}
                        </span>
                    </div>
                    <m-add @click="addColumn(column)"
                           :title="$i18n.translate('m-organize-table-columns:add-column')" />
                </div>
            </m-list-item>
        </ul>
    </template>
</div>
